import { useContext, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import { LanguageContext } from './LanguageContext';
import { useCookieConsent } from '../utils/useCookieConsent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

function CookiePolicy() {
    const {textContent, language } = useContext(LanguageContext);
    const {
        showCookieSettings,
        cookiePreferences,
        handleOpenSettings,
        handleCloseSettings,
        handleSettingChange,
        handleConfirmSettings        
    } = useCookieConsent();
    
    useEffect(() => {
        if (textContent && textContent.companyName && textContent.CookiePolicy) {
            setTimeout(() => {
                document.title = `${textContent.companyName} | ${textContent.CookiePolicy}`;
            }, 0);
        }

        if (language === 'th') {
            document.title = `บริษัท เอไอ บิสซิเนส เทคโนโลยี จำกัด | นโยบายการใช้คุกกี้`;
        } else {
            document.title = `AI Business Technology Co., Ltd. | Cookie Policy`;
        }

    }, [textContent, language]);

    return (
        <div className="bg-gray-100 min-h-screen">
            <Header />

            <main className="container mx-auto px-4 py-8">
                {language === 'th' ? (
                    <>
                        <h1 className="text-4xl font-bold mb-10 text-center">นโยบายการใช้คุกกี้</h1>
                        <p className="text-gray-700 mb-4">
                            เว็บไซต์นี้ใช้คุกกี้เพื่อปรับปรุงประสบการณ์การใช้งานของคุณและช่วยให้เว็บไซต์ทำงานได้อย่างมีประสิทธิภาพยิ่งขึ้น
รายละเอียดการใช้คุกกี้มีดังต่อไปนี้:
                        </p>

                        <h2 className="text-2xl font-bold mb-2">1. คุกกี้คืออะไร</h2>
                        <p className="text-gray-700 mb-4">
                            คุกกี้คือไฟล์ข้อความขนาดเล็กที่ถูกจัดเก็บไว้ในอุปกรณ์ของคุณ (เช่น คอมพิวเตอร์ สมาร์ตโฟน หรือแท็บเล็ต)  
                            เมื่อคุณเข้าเยี่ยมชมเว็บไซต์ด้วยเว็บเบราว์เซอร์ คุกกี้จะช่วยจดจำการใช้งานครั้งก่อน ๆ และทำให้การเข้าใช้งานครั้งถัดไปสะดวกและตรงความต้องการมากขึ้น
                        </p>

                        <h2 className="text-2xl font-bold mb-2">2. ประเภทของคุกกี้ที่เราใช้</h2>
                        <ul className="list-disc pl-6 text-gray-700 mb-4">
                            <li><strong>คุกกี้จำเป็น:</strong> เพื่อจัดเก็บข้อมูลที่จำเป็นต่อการทำงานของเว็บไซต์ ได้แก่ การยอมรับนโยบายการใช้งานคุกกี้</li>
                            <li><strong>คุกกี้การทำงาน:</strong> เพื่อจดจำการตั้งค่าของผู้ใช้ ได้แก่ ภาษาที่แสดงบนเว็บไซต์</li>
                            <li><strong>คุกกี้วิเคราะห์:</strong> เพื่อช่วยวิเคราะห์พฤติกรรมการใช้งานเว็บไซต์</li>                                                        
                        </ul>

                        <h2 className="text-2xl font-bold mb-2">3. การจัดการและการปฏิเสธคุกกี้</h2>
                        <p className="text-gray-700 mb-4">
                            คุณสามารถลบคุกกี้ได้ผ่านการตั้งค่าของเบราว์เซอร์ของคุณ นอกจากนี้ คุณยังสามารถจัดการการยินยอมการใช้คุกกี้ของเว็บไซต์นี้ได้โดยคลิก
                            <button
                            type="button"
                            onClick={handleOpenSettings}
                            className="ml-2 inline-flex items-center text-blue-900 underline decoration-dotted cursor-pointer hover:text-blue-800 bg-transparent border-none p-0"
                            >
                            {textContent.settings}
                            </button>&nbsp;
                            โปรดทราบว่าการปิดการใช้งานคุกกี้บางประเภทอาจทำให้เว็บไซต์บางส่วนไม่สามารถทำงานได้อย่างสมบูรณ์
                        </p>                        
                        <h2 className="text-2xl font-bold mb-2">4. การเปลี่ยนแปลงนโยบายคุกกี้</h2>
                        <p className="text-gray-700 mb-4">
                            บริษัทอาจปรับปรุงนโยบายคุกกี้เป็นครั้งคราว เพื่อให้สอดคล้องกับเทคโนโลยีและข้อกฎหมายที่เปลี่ยนแปลง หากมีการเปลี่ยนแปลงจะประกาศผ่านเว็บไซต์
                        </p>

                        <h2 className="text-2xl font-bold mb-2">5. การติดต่อ</h2>
                        <p className="text-gray-700 mb-4">
                            หากท่านมีข้อสงสัย หรือประสงค์จะใช้สิทธิใด ๆ เกี่ยวกับข้อมูลส่วนบุคคล กรุณาติดต่อ:
                        </p>
                        <p className="text-gray-700 mb-4">
                            <b>บริษัท เอไอ บิสซิเนส เทคโนโลยี จำกัด</b><br />
                            อีเมล: <span className='underline decoration-dotted'>info@aibusiness.co.th</span><br />                            
                            โทรศัพท์: 061-253-0020
                        </p>
                    </>
                ) : (
                    <>
                        <h1 className="text-4xl font-bold mb-10 text-center">Cookie Policy</h1>
                        <p className="text-gray-700 mb-4">
                            This website uses cookies to enhance your experience and help the website function efficiently.
                        </p>

                        <h2 className="text-2xl font-bold mb-2">1. What are cookies</h2>
                        <p className="text-gray-700 mb-4">
                            Cookies are small text files stored on your device (computer, smartphone, or tablet) when you visit websites.  
                            They help remember previous interactions to make your future visits more convenient and efficient.
                        </p>

                        <h2 className="text-2xl font-bold mb-2">2. Types of cookies we use</h2>
                        <ul className="list-disc pl-6 text-gray-700 mb-4">
                            <li><strong>Strictly Necessary Cookies:</strong> To store information necessary for the functioning of the website, i.e., the acceptance of the cookie policy</li>
                            <li><strong>Functionality Cookies:</strong> To remember user settings, i.e., website language</li>
                            <li><strong>Analytical Cookies:</strong> To analyze website usage behavior</li>                                                        
                        </ul>

                        <h2 className="text-2xl font-bold mb-2">3. Managing and rejecting cookies</h2>
                        <p className="text-gray-700 mb-4">
                            You can delete cookies through your browser settings. In addition, you can manage your consent for this website's cookies by clicking
                            <button
                            type="button"
                            onClick={handleOpenSettings}
                            className="ml-2 inline-flex items-center text-blue-900 underline decoration-dotted cursor-pointer hover:text-blue-800 bg-transparent border-none p-0"
                            >
                            {textContent.settings}
                            </button>.&nbsp;
                            Please note that disabling certain types of cookies may affect the proper functioning of some parts of the website.
                        </p>

                        <h2 className="text-2xl font-bold mb-2">4. Changes to this cookie policy</h2>
                        <p className="text-gray-700 mb-4">
                            The Company may update this policy from time to time to reflect technology or legal changes. Updates will be announced via the website.
                        </p>

                        <h2 className="text-2xl font-bold mb-2">5. Contact</h2>
                        <p className="text-gray-700 mb-4">
                            If you have any questions or wish to exercise any rights regarding your personal data, please contact:
                        </p>
                        <p className="text-gray-700 mb-4">
                            <b>AI Business Technology Co., Ltd.</b><br />
                            Email: <span className='underline decoration-dotted'>info@aibusiness.co.th</span><br />
                            Phone: 061-253-0020
                        </p>
                    </>
                )}
            </main>

            <Footer />

            {/* Cookie Settings Modal */}
            {showCookieSettings && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ">
                    <div className="bg-white rounded-lg shadow-lg max-w-2xl w-full mx-4 max-h-128 overflow-y-auto">
                        <div className="flex justify-between items-center border-b p-6">
                            <h2 className="text-2xl font-bold text-gray-800">{textContent.cookiePreferences}</h2>
                            <button
                                onClick={handleCloseSettings}
                                className="text-gray-600 hover:text-gray-800"
                                aria-label={textContent.close}
                            >
                                <FontAwesomeIcon icon={faTimes} size="lg" />
                            </button>
                        </div>
                        
                        <div className="p-6 space-y-6">
                            {/* Necessary Cookies */}
                            <div className="border rounded-lg p-4 bg-gray-50">
                                <div className="flex justify-between items-start">
                                    <div className="flex-1">
                                        <h3 className="text-lg font-semibold text-gray-800">
                                            {textContent.necessaryCookies}
                                        </h3>
                                        <p className="text-gray-600 text-sm mt-1">
                                            {textContent.necessaryCookiesDesc}
                                        </p>
                                    </div>
                                    <div className="ml-4">
                                        <span className="inline-block bg-blue-900 text-white px-3 py-1 rounded-full text-sm font-medium">
                                            {textContent.accept}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Functional Cookies */}
                            <div className="border rounded-lg p-4">
                                <div className="flex justify-between items-start">
                                    <div className="flex-1">
                                        <h3 className="text-lg font-semibold text-gray-800">
                                            {textContent.functionalCookies}
                                        </h3>
                                        <p className="text-gray-600 text-sm mt-1">
                                            {textContent.functionalCookiesDesc}
                                        </p>
                                    </div>
                                    <div className="ml-4">
                                        <label className="flex items-center cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={cookiePreferences.functional}
                                                onChange={() => handleSettingChange('functional')}
                                                className="w-5 h-5 text-blue-900 rounded focus:ring-2 focus:ring-blue-500"
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {/* Analytics Cookies */}
                            <div className="border rounded-lg p-4">
                                <div className="flex justify-between items-start">
                                    <div className="flex-1">
                                        <h3 className="text-lg font-semibold text-gray-800">
                                            {textContent.analyticsCookies}
                                        </h3>
                                        <p className="text-gray-600 text-sm mt-1">
                                            {textContent.analyticsCookiesDesc}
                                        </p>
                                    </div>
                                    <div className="ml-4">
                                        <label className="flex items-center cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={cookiePreferences.analytics}
                                                onChange={() => handleSettingChange('analytics')}
                                                className="w-5 h-5 text-blue-900 rounded focus:ring-2 focus:ring-blue-500"
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="border-t p-6 flex justify-end space-x-2">
                          
                            <button
                                onClick={handleConfirmSettings}
                                className="px-6 py-2 bg-blue-900 text-white rounded-lg hover:bg-blue-800"
                            >
                                {textContent.confirmSettings}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default CookiePolicy;
